/* eslint-disable */
import { Alert as AntdAlert } from 'antd';
import React, { FC } from 'react';
import { Alert } from 'components/atoms/alert';

export const DemoAlertPage: FC = () => (
  <>
    <h3>Alert from antd</h3>
    <AntdAlert message="This is an alert message" showIcon type="info" />
    <h3>Alert from app</h3>
    <Alert message="This is an alert message" showIcon type="info" />
    <h3>Alert without type used in document section</h3>
    <Alert message="This is an alert message" showIcon />
    <h3>Warning alert from app</h3>
    <Alert message="This is an warning message" showIcon type="warning" />
  </>
);
